import {
  AgStepbarItem,
  AgDropMenu,
  AgDropMenuContent
} from '@rededor/ag-shared-components-react'
import { format, parseISO } from 'date-fns'
import { useStepStatus } from '@/hooks/useStepStatus'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useStepAction } from './useStepAction'
import { birthDateSchema, genderSchema } from '@/app/paciente/patientSchema'
import { validateField } from '@/app/paciente/utils'

export const PatientStep = () => {
  const patient = useScheduleStore((state) => state.patient)
  const targetStep = 'patient'
  const { handleClickAction, handleSelectStep } = useStepAction('/paciente')

  const formatBirthDate = patient?.birthDate
    ? format(parseISO(patient.birthDate), 'dd/MM/yyyy')
    : ''
  const genderName =
    patient?.gender === 'M'
      ? 'Masculino'
      : patient?.gender === 'F'
        ? 'Feminino'
        : ''
  const info =
    formatBirthDate && genderName ? `${formatBirthDate} - ${genderName}` : ''

  const birthDateValidation = validateField(birthDateSchema, formatBirthDate)
  const genderValidation = validateField(genderSchema, patient?.gender!)

  const status = useStepStatus({
    isCompleted:
      Boolean(birthDateValidation.isValid) && Boolean(genderValidation.isValid),
    targetPath: '/paciente',
    targetStep
  })

  return (
    <AgStepbarItem
      step="Paciente"
      info={info}
      icon="profile"
      onSelectStep={handleSelectStep}
      status={status}
      targetStep={targetStep}
    >
      <AgDropMenu>
        <AgDropMenuContent
          step="Paciente"
          info={info}
          labelAction="Alterar informações do paciente"
          onClickAction={handleClickAction}
        />
      </AgDropMenu>
    </AgStepbarItem>
  )
}
